import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Uploadimg = _resolveComponent("Uploadimg")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.show) = $event)),
      onClose: _ctx.close,
      title: _ctx.isEdit ? '编辑活动支持' : '新增活动支持',
      center: "",
      width: "50%",
      "before-close": _ctx.handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: _ctx.close }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitForm
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("提交", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "ruleFormRef",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-width": "120px",
              class: "demo-ruleForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "活动名",
                  prop: "activeName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.activeName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.activeName) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "封面",
                  prop: "fileId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Uploadimg, {
                      image: _ctx.ruleForm.fileUrl,
                      onOnSuccess: _ctx.onSuccess
                    }, null, 8, ["image", "onOnSuccess"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "状态",
                  prop: "activeStatus"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.ruleForm.activeStatus,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.activeStatus) = $event)),
                      label: "0",
                      size: "large"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("直播结束", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_radio, {
                      modelValue: _ctx.ruleForm.activeStatus,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.activeStatus) = $event)),
                      label: "1",
                      size: "large"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("正在直播", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "描述",
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "跳转链接",
                  prop: "linkUrl"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.linkUrl,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.linkUrl) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onClose", "title", "before-close"])
  ]))
}